import { formatNumber } from "./formatters";

export const isZero = (value: number, numDecimals: number): boolean =>
    formatNumber(value, {
        numDecimals,
    }) ===
    formatNumber(0, {
        numDecimals,
    });
